// A Content Optimization order's fulfilment status (2026-10-02, Eric). Any
// Bison staff session moves it (Merchandising, the account manager, Finance);
// the supplier reads it on Checkout. An order with no status is "placed".
export const CO_ORDER_STATUSES = ["placed", "review", "in_progress", "delivered", "finance", "settled"] as const;
export type CoOrderStatus = (typeof CO_ORDER_STATUSES)[number];

export const CO_ORDER_STATUS_LABELS: Record<CoOrderStatus, string> = {
    placed: "Order placed",
    review: "Review / missing info",
    in_progress: "In progress",
    delivered: "Deliverables sent",
    finance: "Finance",
    settled: "Settled",
};

export interface CoDeliverable {
    label?: string;
    url: string;
}
